import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, GeoJSON, LayersControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import { MapHomeControl, MapInfoControl, MapLegendControl } from "../../common/MapControls/MapControls";


const Livestock = () => {
    const [goatData, setGoatData] = useState(null);
    const [horseData, setHorseData] = useState(null);

    const center = [-8.8742, 125.7275]; // Timor-Leste
    const INITIAL_VIEW_STATE = {
        zoom: 8.5,
    };



    // Fetch boundary data (Country layer)
    useEffect(() => {
        fetch("/Exposure/Goats.geojson")
            .then((response) => response.json())
            .then((data) => setGoatData(data))
            .catch((error) => console.error("Error loading boundary data:", error));
    }, []);

    useEffect(() => {
        fetch("/Exposure/Horses.geojson")
            .then((response) => response.json())
            .then((data) => { setHorseData(data); })
            .catch((error) => console.error("Error loading line data:", error));
    }, []);



    return (
      <div className="mapcontainerall">
        <MapContainer
            center={center}
            zoom={INITIAL_VIEW_STATE.zoom}
            style={{ height: "100%", width: "100%" }}
        >
          <MapHomeControl />
          <MapInfoControl text="Livestock distribution across Timor-Leste used for fire risk exposure assessment." />
            {/* Base tile layer */}
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {/* Layer Control */}
            <LayersControl position="topright">

                {goatData && (
                    <LayersControl.Overlay name="Goat" checked>
                        <GeoJSON
                            data={goatData}
                            style={() => ({
                                color: "green", // Style for the Goat layer
                                weight: 2,
                                fillColor: "lightgreen",
                                fillOpacity: 0.5,
                            })}
                            onEachFeature={(feature, layer) => {
                                // Add a popup or other interactions for Goat features
                                if (feature.properties && feature.properties.name) {
                                    layer.bindPopup(`<b>Goat Feature:</b> ${feature.properties.name}`);
                                }
                            }}
                        />
                    </LayersControl.Overlay>
                )}

                {horseData && (
                <LayersControl.Overlay name="Horse" checked>
                    <GeoJSON
                    data={horseData}
                    pointToLayer={(feature, latlng) => 
                        L.circleMarker(latlng, {
                        radius: 2, // Size of the circle
                        color: "blue", // Border color
                        weight: 2, // Border thickness
                        fillColor: "lightblue", // Fill color
                        fillOpacity: 0.6, // Transparency
                        })
                    }
                    onEachFeature={(feature, layer) => {
                        // Add a popup for each circle
                        if (feature.properties && feature.properties.name) {
                        layer.bindPopup(`<b>Horse Feature:</b> ${feature.properties.name}`);
                        }
                    }}
                    />
                </LayersControl.Overlay>
                )}



            </LayersControl>
            <MapLegendControl
              sections={[{
                shape: "square",
                items: [
                  { label: "Goat Data", color: "Green" },
                  { label: "Horse Data", color: "blue" },
                ],
              }]}
            />
        </MapContainer>
        </div>
    );
};

export default Livestock;

